import { DenominationAmountByServiceIdType } from '../model/denomination.types'

export const findFirstAvailableDenominationByCountry = <T extends { serviceId: string }>(
  denominations: Record<string, T[]>,
  country: string | null,
  pricesByServiceId: DenominationAmountByServiceIdType
) => {
  if (!country) {
    return null
  }

  const denominationsList = denominations[country]

  if (!denominationsList || denominationsList.length === 0 || !pricesByServiceId) {
    return null
  }

  const firstAvailable = denominationsList.find((payee) => {
    const price = pricesByServiceId[payee.serviceId]

    return price && price.base !== ''
  })

  return firstAvailable || null
}
